import CaseListController from './CaseListController';

export default CaseListController;